<template>
  <div class="d-flex flex-column justify-start align-center overflow-x-hidden">
    <v-row align="center" justify="center" class="px-5 mb-2 mt-2 w-100 flex-column" v-if="data.id">
        <v-row justify="start" align="center" class="w-100" v-if="data && data.content">
            <v-img
                src="/img/user/soundicon.svg"
                max-height="45px"
                max-width="45px"
                contain
                class="main-sound-img cursor-pointer ma-3"
                @click="readText(questionContent)"
            ></v-img>
            <div
                :class="`d-flex flex-col px-0 justify-start w-80 align-center ${isInitialReader ? 'text-h5': 'text-h6'} primary--text text-justify font-weight-medium`"
                v-html="visualContent"
            >
            </div>
        </v-row>
        <v-row class="w-100 pa-0" align="center" justify="center"
               v-if="!isImage && item_type === 'CLOSED_4OPTIONS'">
                <TextOption
                    v-for="(answer, index) of data.answers"
                    class="w-100 pa-0 transition-all" :key="index"
                    :answer="answer"
                    :question="data"
                    :selected="answer.id === btnSelected.id"
                    :correct="answer.id === correct"
                    :incorrect="answer.id === incorrect"
                    data-cy="questionItem-closed4Options-btn"
                    :data-question-identifier="`question-${data.id}-answer-${answer.id}`"
                    @select="setSelectedBtn(answer.id, answer.id, answer.itemNumber)"
                    is-reading/>
        </v-row>
        <v-row class="w-100" align="center" justify="center"
               v-if="!isImage && item_type === 'CLOSED_TRUE_FALSE'">
            <TextOption
                class="w-100"
                :answer="{id: data.id, content: $t('true'), item: data.answerTrueOrFalse }"
                :question="data"
                :selected="'1' === btnSelected.value"
                :correct="'1' === correct"
                :incorrect="'1' === incorrect"
                data-cy="questionItem-trueItemclosedTrueFalse-btn"
                :data-question-identifier="`question-${data.id}-answer-1`"
                @select="setSelectedBtn(data.id, '1', data.answerTrueOrFalse)"
                is-reading/>
            <TextOption
                class="w-100"
                :answer="{id: data.id, content: $t('false'), item: data.answerTrueOrFalse }"
                :question="data"
                :selected="'0' === btnSelected.value"
                :correct="'0' === correct"
                :incorrect="'0' === incorrect"
                data-cy="questionItem-trueItemclosedTrueFalse-btn"
                :data-question-identifier="`question-${data.id}-answer-0`"
                @select="setSelectedBtn(data.id, '0', data.answerTrueOrFalse)"
                is-reading/>
        </v-row>
        <v-row class="w-100" align="end" justify="center"
               v-if="isImage && item_type === 'CLOSED_4OPTIONS' ">
            <ImageOption v-for="(answer, index) of data.answers"
                         class="pa-0 w-25 transition-all" :key="index"
                         :answer="answer" :question="data"
                         :selected="answer.id === btnSelected.id"
                         :data-question-identifier="`question-${data.id}-answer-${answer.id}`"
                         @select="setSelectedBtn(answer.id, answer.id, answer.itemNumber)"
                         :isReading="true"
            ></ImageOption>
        </v-row>
    </v-row>
  </div>
</template>
<script>
import TextOption from "../../../../core/utils/items/TextOption.vue";
import ImageOption from "../../../../core/utils/items/ImageOption.vue";
import SpeechSynthesis from "../../../../../mixins/SpeechSynthesis";
import initialReaderValidation from "../../../../../mixins/InitialReaderValidation";
import { mapState } from 'vuex';

export default {
  components: {TextOption, ImageOption},
  props: {
    data: { type: Object, default: null },
    item_type: { type: [Number, String], default: '' },
    correct: { type: [Number, String], default: 0 },
    incorrect: { type: [Number, String], default: 0 },
    isClassCorrect: { type: Boolean, default: false },
    cleanSelection: { type: Number, default: 0 },
  },
  data() {
    return {
      btnSelected: {
        id: null,
        value: null,
        secret: null,
      },
      questionFormat: 1,

    }
  },
  methods: {
    classSelected(answerValue) {
      const colorText = answerValue === this.btnSelected.id ? 'white--text' : 'primary--text'
      return `w-100 my-3 transition-all cursor-pointer pa-2 border-radius-1 text-none option-btn ${colorText} ${this.bgColor(
        answerValue
      )}`
    },
    classSelectedTrueOrFalse(answerValue) {
      const colorText = answerValue === this.btnSelected.value ? 'white--text' : 'primary--text'
      return `w-100 my-3 transition-all cursor-pointer pa-2 border-radius-1 text-none option-btn ${colorText} ${this.bgColorTrueOrFalse(
        answerValue
      )} `
    },
    bgColor(answerValue) {
      let result = answerValue === this.btnSelected.id ? 'primary' : 'white'
      if (answerValue === this.correct) {
        result = 'correct'
      }
      if (answerValue === this.incorrect) {
        result = 'incorrect'
      }
      return result
    },
    bgColorTrueOrFalse(answerValue) {
      let result = answerValue === this.btnSelected.value ? 'primary' : 'white'
      if (answerValue === this.correct) {
        result = 'correct'
      }
      if (answerValue === this.incorrect) {
        result = 'incorrect'
      }
      return result
    },
    setSelectedBtn(answerId, answerValue, answerSecret) {
      this.btnSelected.id = answerId
      this.btnSelected.value = answerValue
      this.btnSelected.secret = answerSecret
      this.$emit('newSelection', this.btnSelected)
    },
    setSelectedBtnTrueOrFalse(answerId, answerValue, answerSecret) {
      this.btnSelected.id = answerId
      this.btnSelected.value = answerValue
      this.btnSelected.secret = `${answerSecret}`
      this.$emit('newSelection', this.btnSelected)
    },
      timeout(ms) {
          return new Promise(resolve => setTimeout(resolve, ms))
      },
      queryElements(query = "") {
          return document.querySelectorAll(query)
      },
      getElementsByQuestionAndAnswer(questionId = 0, answerId = 0) {
          return questionId && answerId ? this.queryElements(`div:is([data-question-identifier=question-${questionId}-answer-${answerId}])`) : []
      },
      setWrongAnswer(questionId = 0, answerId = 0) {
          const vm = this;
          const elements = this.getElementsByQuestionAndAnswer(questionId, answerId)
          if (elements.length) {
              elements.forEach(el => {
                  vm.setStyleForWrongAnswer(el)
              })
          }
      },
      setCorrectAnswer(questionId = 0, answerId = 0) {
          const vm = this;
          const elements = this.getElementsByQuestionAndAnswer(questionId, answerId)
          if (elements.length) {
              elements.forEach(el => {
                  vm.setStyleForCorrectAnswer(el)
              })
          }
      },
      async setStyleForWrongAnswer(el = null) {
          if (el) {
              el.classList.add('filter-gray');
              await this.timeout(500);
              el.classList.add('animated', 'fadeOut');
              await this.timeout(500);
              el.classList.add('d-none');
              await this.timeout(200);
              this.validateAndScaleOption();
          }
      },
      async setStyleForCorrectAnswer(el = null) {
          if (el) {
              el.classList.add('correct', 'animated', 'bounce');
              await this.timeout(1000);
              el.classList.remove('bounce')
          }
      },
      cleanStyles() {
          const CLASSES_TO_CLEAN = '.option.correct,.option.d-none, .option.filter-gray, .option.scale-1, .option.animated, .option.fadeOut';
          const elements = this.queryElements(CLASSES_TO_CLEAN);
          if (elements.length) {
              elements.forEach(el => {
                  el.classList.remove('correct', 'd-none', 'filter-gray', 'scale-1', 'animated', 'fadeOut')
              })
          }
      },
      validateAndScaleOption() {
          const allOptions = this.queryElements('.option');
          const hiddenOptions = this.queryElements('.option.d-none');
          const remaining = allOptions.length - hiddenOptions.length;
          if (allOptions.length && hiddenOptions.length && remaining === 1 ) {
              const options = this.queryElements('.option');
              options.forEach(el => {
                  if (!el.classList.contains('d-none')) el.classList.add('scale-1');
              })
          }
      }
  },
    computed: {
        ...mapState({
            course: (state) => state.userData.user.course,
        }),
        questionTemplate() {
            return this.data.questionTemplate?.value
        },
        isImage() {
            const vm = this;
            return [3, 4].some(item => vm.questionTemplate === item)
        },
        visualContent() {
            return this.data.content.replace('_', `
                        <span class="completion-space mx-3 elevation-3 transition-all" id="question-${this.data.id}"></span>
                        `).replace(/_/g, '')
        },
        questionContent() {
            return this.data.content.replace(/_/g, '.')
        }
    },
  watch: {
    cleanSelection() {
      this.btnSelected = {
        id: null,
        value: null,
        secret: null,
      }
    },
  },
  mixins: [SpeechSynthesis, initialReaderValidation]
}
</script>

<style>
.icon {
  border-radius: 500px;
}

.icon i {
  font-size: 24px;
  font-weight: bolder;
}


.option-btn {
    border: thin solid;
    border-color: #514773 !important;
    font-size: 0.9rem;
    max-width: 100%;
}

.option {
    transform: scale(.95);
}

.filter-gray {
    filter: grayscale(1);
}

.scale-1 {
    transform: scale(1.05) !important;
}

.correct .alternative {
    background: #147a06 !important;
    color: white !important;
}

.correct .alternative-image {
    border: #147a06 solid 1vh !important;
    color: white !important;
    transform: scale(1.1);
}

</style>
